// Core React Imports
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Local Imports
import PageWelcome from "./pages/page-welcome/PageWelcome.jsx";
import PageFilter from "./pages/page-filter/PageFilter.jsx";
import PageTerminalInfo from "./pages/page-terminal-info/PageTerminalInfo.jsx";
import PageModelInfo from "./pages/page-model-info/PageModelInfo.jsx";
import PageDashboard from "./pages/page-dashboard/PageDashboard.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { DivMain, DivRtl } from "./styles/SharedStyles";
import { WidgetLoading } from "./widgets/loadings/WidgetLoading";
import WidgetAlertDialogUsers from "./widgets/alert-dialogs/widget-alert-dialog-users/WidgetAlertDialogUsers.jsx";
import ConstantsPages from "./constants/ConstantsPages.js";
import ConstantsParams from "./constants/ConstantsParams.js";
import { useSelector } from "react-redux";

// CSS/Stylesheets
import "./App.css";

function App() {
  const location = useLocation();
  const isUsersDialogOpen = useSelector((state) => state.dialog.isUsersDialogOpen);

  return (
    <div className="App">
      <WidgetLoading>
        <DivRtl>
          <DivMain>
            <Routes>
              <Route path={ConstantsPages.PAGE_WELCOME} element={<PageWelcome />} />
              <Route
                path={ConstantsPages.PAGE_FILTER}
                element={
                  <ProtectedRoute>
                    <PageFilter />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ConstantsPages.PAGE_TERMINAL_INFO}
                element={
                  <ProtectedRoute>
                    <PageTerminalInfo key={location.state?.timestamp} />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ConstantsPages.PAGE_MODEL_INFO}
                element={
                  <ProtectedRoute requiredRole={ConstantsParams.UserTypeTerminalStatus.EDITOR}>
                    <PageModelInfo />
                  </ProtectedRoute>
                }
              />
              <Route
                path={ConstantsPages.PAGE_DASHBOARD}
                element={
                  <ProtectedRoute>
                    <PageDashboard />
                  </ProtectedRoute>
                }
              />
              {/* Default route - redirect to welcome page */}
              <Route path="*" element={<PageWelcome />} />
            </Routes>
          </DivMain>
          {isUsersDialogOpen && <WidgetAlertDialogUsers />}
        </DivRtl>
      </WidgetLoading>
    </div>
  );
}

export default App;
